/**
 * 2026-10-07 presence-states follow-up — reads the dashboard tile counts
 * straight off the /dashboard response, no arithmetic. totalOnlineDevice
 * itself is UNCHANGED in name and meaning (it already includes standby/
 * app_closed, since both require a fresh last_login to even be reachable).
 *
 * Build 380 fix (item I): the "شاشات تعمل الآن" tile used to be derived
 * here by SUBTRACTING standby/app_closed from totalOnlineDevice — that is
 * still a client-side computation of device status, which the standing
 * rule forbids even as a derivation, not just as a from-scratch decision.
 * totalOnlineNowDevice is now computed backend-side
 * (DashboardController::index(), from Device::connectivity()) and simply
 * read here.
 */
export function deriveDeviceCounts(data) {
  const total = data?.totalDevice ?? 0;
  const standby = data?.totalStandbyDevice ?? 0;
  const appClosed = data?.totalAppClosedDevice ?? 0;
  const offline = data?.totalOfflineDevice ?? 0;
  const onlineOnly = data?.totalOnlineNowDevice ?? 0;
  const notShowingNow = standby + appClosed;

  return { total, onlineOnly, standby, appClosed, offline, notShowingNow };
}
